import 'moment/locale/id';
import * as ExcelJS from 'exceljs';
import { ListProduct } from '../../interfaces/Pipeline';
import { TableColumn } from 'react-data-table-component';
import moment from 'moment';
import { Merchant } from '../../interfaces/Merchant';
import 'moment-duration-format';
import { UserModel } from '../../app/modules/auth/models/UserModel';
import { generateLabel } from './exportExcelUtil';
import { CRMColumnDef } from '../../components/DataTable/MasterDataTableTanstack';
import { currencyFormatter, sortColumnDatatable } from '../general';
import { IntlShape } from 'react-intl';
import { SettingMultiMerchants } from '../../interfaces/Settings';
import { checkIsCompanyVaporesia } from '../customCase';
import { CustomeStoreCompanyIdProps } from '../../stores/CustomeStore';

const formatCustomField = (row: any, field: string, type: string, user: UserModel) => {
  const valueInfoCustomFields = (row.info_custom_fields && row.info_custom_fields[field]) ? row.info_custom_fields[field] : [];
  const value = row.customFields[field];
  if (type === 'meeting') return valueInfoCustomFields.length > 0 ? valueInfoCustomFields.map((item: any) => `${item.merchant_name} / ${moment(item.date_meet).format('DD MMM YYYY')} / ${item.meeting_status}`).join(', ') : '-';
  else if (type === 'pipeline') return valueInfoCustomFields.length > 0 ? valueInfoCustomFields.map((item: any) => `${item.name} / ${currencyFormatter(item.nominal, user?.data?.companyCurrencyNeedRound, user?.data?.companyCurrency, { showPrefix: true })} / ${moment(item.dateCreated).format('DD MMM YYYY')}`).join(', ') : '-';
  else if (type === 'merchant') return valueInfoCustomFields.length > 0 ? valueInfoCustomFields.map((item: any) => item.merchant_name).join(', ') : '-';
  else if (type === 'user') {
    return valueInfoCustomFields.length > 0 ? valueInfoCustomFields.map((item: any) => item.name).join(', ') : '-';
  }
  else if (type === 'invoice_reminder') {
    const parsedValue = JSON.parse(value);
    return [
      parsedValue.invoice_url,
      parsedValue.date_due ? moment(parsedValue.date_due).format('DD MMM YYYY') : '-',
    ];
  }
  else if (type === 'date') {
    return value ? moment(value).format('YYYY-MM-DD') : '-';
  }
  else if (type === 'dateTime') {
    return value ? moment(value).format('YYYY-MM-DD HH:mm') : '-';
  }
  else if (type === 'multiple' || type === 'multipleOption') {
    return value ? value.toString().split(',').join(', ') : '-';
  }
  else if (type === 'images' || type === 'files' || type === 'videos') {
      return value ? value.toString().split(',').join('\n ') : '-';
  }
  else if (type === 'serial') {
    return value ? value.join('') : '-';
  }
  else if (type === 'dateTimeRange') {
    return value
      ? (typeof value === 'string'
        ? value.split(',').map((item: any) => moment(item).format('YYYY-MM-DD HH:mm')).join(' - ')
        : Array.isArray(value)
          ? value.map((item: any) => moment(item).format('YYYY-MM-DD HH:mm')).join(' - ')
          : value)
      : '-';
  }
  else if (type === 'time') {
    return value
      ? (typeof value === 'string'
        ? value.split(',').map((item: any) => moment(item).format('HH:mm')).join(' - ')
        : Array.isArray(value)
          ? value.map((item: any) => moment(item).format('HH:mm')).join(' - ')
          : value)
      : '-';
  } else if (type === 'product') return valueInfoCustomFields.length > 0 ? valueInfoCustomFields.map((item: any) => item.product_name).join(', ') : '-';
  else {
    return value;
  }
};

const styleColumns = (
  worksheet: ExcelJS.Worksheet,
  source: string,
  param: any,
  columns: CRMColumnDef<Merchant>[],
  indexRow: number,
  user?: UserModel,
  isFilterDate?: boolean
) => {
  worksheet.getRow(isFilterDate ? 4 : indexRow).alignment = {
    vertical: 'middle',
    horizontal: 'center',
    wrapText: true,
  };
  worksheet.getRow(isFilterDate ? 4 : indexRow).eachCell(function (cell) {
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: {
        argb: 'F6991D',
      },
    };
  });
  worksheet.getRow(isFilterDate ? 4 : indexRow).font = {
    name: 'Arial Black',
    size: 10,
    bold: true,
  };
  worksheet.getRow(isFilterDate ? 5 : indexRow + 1).eachCell(function (cell) {
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: {
        argb: 'F8B219',
      },
    };
  });
};

const exportWorkbook = async (workbook: ExcelJS.Workbook, source: string, fileName: string) => {
  if (source === 'Report Logs Pipeline') {
    const report = await workbook.xlsx.writeBuffer().then((buffer) => {
      // Konversi buffer ke blob
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const excelFile = new File([blob], `${fileName}.xlsx`, { type: blob.type, lastModified: Date.now() });
      return excelFile;
    });
    return report;
  } else {
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      a.click();
    });
  }
};

export const exportExcelMerchant = async (
  nameFile: string,
  source: string,
  nameHeader: any,
  param: any,
  selectMultiMerchant: any,
  intl: IntlShape,
  data?: any[],
  columns?: CRMColumnDef<Merchant>[],
  user?: UserModel,
  dateStart?: any,
  dateEnd?: string,
  isFilterDate?: boolean,
  companyId?: CustomeStoreCompanyIdProps
) => {
  let exportData: any[] = [];
  var arrayCustomFieldMerchants = Object.keys(selectMultiMerchant).length !== 0
    ? selectMultiMerchant.customFields
    : [];


  let comapnyCodeIndex = -1;
  let comapnyNameIndex = -1;
  let nameIndex1 = -1;
  let nameIndex2 = -1;

  const workbook = createWorkbook();
  const worksheet = createWorksheet(workbook, source);


  if (source === 'Merchant') {
    if (isFilterDate && dateStart && dateEnd) {
      addFileInformationDateRange(worksheet, dateStart, dateEnd);
    }

    const returnSubHeader = () => {
      return Object.keys(arrayCustomFieldMerchants).map((field: any) => {
        if (arrayCustomFieldMerchants[field].type === 'date') return 'Format (YYYY-MM-DD)'
        else if (arrayCustomFieldMerchants[field].type === 'dateTime') return 'Format (YYYY-MM-DD HH:mm)'
        else if (arrayCustomFieldMerchants[field].type === 'dateTimeRange') return 'Format (YYYY-MM-DD HH:mm - YYY-MM-DD HH:mm)'
        else if (arrayCustomFieldMerchants[field].type === 'time') return 'Format (HH:mm)'
        else return ''
      })
    }

    var header = [...nameHeader.merchant.header, ...Object.keys(arrayCustomFieldMerchants).map((field: any) => arrayCustomFieldMerchants[field].name)]
    var subHeader = [...nameHeader.merchant.subHeader, ...returnSubHeader()]

    if (user!.data.company_id === '7763fccc-af52-43e1-8907-4678ab2423d1') {
      comapnyCodeIndex = header.map((item) => item.toLowerCase()).indexOf('company code');
      nameIndex1 = header.findIndex(col => col.toLowerCase() === 'name' || col.toLowerCase() === 'nama');
      comapnyCodeIndex !== -1 && sortColumnDatatable(header, comapnyCodeIndex, nameIndex1);

      comapnyNameIndex = header.map((item) => item.toLowerCase()).indexOf('company name');
      nameIndex2 = header.findIndex(col => col.toLowerCase() === 'name' || col.toLowerCase() === 'nama');
      comapnyNameIndex !== -1 && sortColumnDatatable(header, comapnyNameIndex, nameIndex2);
    }

    worksheet.getRow(isFilterDate ? 4 : 1).values = header
    worksheet.getRow(isFilterDate ? 5 : 2).values = subHeader

    if (!data) return console.error(`Data ${source} - Export is empty`);

    Array.from(data!).map((row, index) => {
      var temp_excel = [];
      temp_excel.push(
        row.name,
        row.ownerName,
        generateLabel(row),
        row.cityName,
        row.phone,
        row.isWhatsappPhone ? 'Valid' : 'Tidak Valid',
        row.email,
        row.lastMeetEnd,
        row.lastLeadCreatedTime,
        user?.data.company_id === "c8e10598-35d6-41ae-b09a-088fb91b9aa7" ? row.leadsPurchasePackageCount : row.leadsCount,
        row.meetingsCount,
        row.creatorName,
        moment(row.dateCreated).format('YYYY-MM-DD HH:mm:ss'),
      );

      if (selectMultiMerchant.customFields) {
        Object.keys(arrayCustomFieldMerchants).forEach((field) => {
          const type = arrayCustomFieldMerchants[field].type;
          const formattedField = formatCustomField(row, field, type, user!);

          if (type === 'invoice_reminder') {
            temp_excel.push(...formattedField);
          } else {
            temp_excel.push(formattedField);
          }
        });
      }

      if (user) {
        if (user!.data.company_id === '7763fccc-af52-43e1-8907-4678ab2423d1' && comapnyCodeIndex !== -1 && comapnyNameIndex !== -1) {
          sortColumnDatatable(temp_excel, comapnyCodeIndex, nameIndex1);
          sortColumnDatatable(temp_excel, comapnyNameIndex, nameIndex2);
        }
      }

      exportData.push(temp_excel);
    });

    addDataRows(worksheet, exportData, source, header, columns!, intl, selectMultiMerchant, user, arrayCustomFieldMerchants);
    setColumnWidths(worksheet, source, arrayCustomFieldMerchants, exportData, checkIsCompanyVaporesia(companyId!, user!));
    styleColumns(worksheet, source, param, columns!, 1, undefined, isFilterDate);
  }


  exportWorkbook(workbook, source, `${nameFile}.xlsx`);
};

const createWorkbook = () => {
  const workbook = new ExcelJS.Workbook();
  workbook.creator = 'Looyal';
  workbook.lastModifiedBy = 'Looyal';
  workbook.created = new Date();
  workbook.modified = new Date();
  return workbook;
};

const createWorksheet = (workbook: ExcelJS.Workbook, source: string, sheetName: string = 'Sheet1') => {
  let worksheet;
  worksheet = workbook.addWorksheet(sheetName);
  return worksheet;
};

const addDataRows = (
  worksheet: ExcelJS.Worksheet,
  data: any[],
  source: string,
  header: string[],
  columns: CRMColumnDef<Merchant>[],
  intl: IntlShape,
  selectMultiMerchant: SettingMultiMerchants,
  user?: UserModel,
  fields?: any,
) => {
  if (source === 'Merchant') {
    // Set Data Body
    data.forEach((rowData, index) => {
      const row = worksheet.addRow(rowData);
      // Adjust cell styling if needed

      row.eachCell((cell, colIndex) => {
        cell.alignment = {
          vertical: 'top',
          wrapText: true,
          shrinkToFit: true,
        };

        const offsetColumns = 13;

        if (colIndex > offsetColumns) {
          const fieldIndex = colIndex - offsetColumns - 1;
          const fieldId = Object.keys(fields)[fieldIndex];

          if (fieldId && fields[fieldId].type === 'number') {
            cell.numFmt = '#,##0;[Red]-#,##0';
          }
        }
      });
    });

    // Dynamic column
    const columnIndicesToRemove: number[] = [];
    if (user?.data.company_id === "7763fccc-af52-43e1-8907-4678ab2423d1") columnIndicesToRemove.push(3)

    // Cari semua indeks kolom yang perlu dihapus
    header.forEach((item, headerIndex) => {
      // console.log('header',item)
      if ((selectMultiMerchant.isFeatureLabelEnabled == false && item === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.LABEL' }))) {
        columnIndicesToRemove.push(headerIndex + 1);
      }

      columns.forEach((column) => {
        if (column.excelColumnHidden && item === column.header) {
          columnIndicesToRemove.push(headerIndex + 1); // +1 untuk 1-based index
        }
      });
    });

    // Hapus kolom dari worksheet berdasarkan indeks yang ditemukan
    columnIndicesToRemove.sort((a, b) => b - a).forEach((index) => {
      worksheet.spliceColumns(index, 1);
    });
  } else {
    // Set Data Body
    data.forEach((rowData, index) => {
      worksheet.addRow(rowData);
    });
  }
};
const setColumnWidths = (worksheet: ExcelJS.Worksheet, source: string, fields: any[], data: any, isCompanyVaporesia?: boolean) => {
  if (source === 'Pipeline' || source === 'Merchant') {
    const maxColumnWidths: number[] = [];
    data.forEach((row: any) => {
      row.forEach((cell: any, columnIndex: number) => {
        const cellLength = String(cell).length;
        if (!maxColumnWidths[columnIndex] || cellLength > maxColumnWidths[columnIndex]) {
          maxColumnWidths[columnIndex] = cellLength;
        }
      });
    });

    // Atur lebar kolom berdasarkan panjang teks terpanjang
    maxColumnWidths.forEach((width, columnIndex) => {
      worksheet.getColumn(columnIndex + 1).width = width < 20 ? 20 : width + 2 > 40 ? 40 : width + 2; // Tambahkan sedikit padding
    });

    const colWidths = [20, 30, 30, 20, 20, 30, isCompanyVaporesia && source === 'Merchant' ? 0 : 30, 20, 20, 20, 20, 20, 20, 20, 20, 20, ...Object.keys(fields).map((field) => 25)];
    worksheet.columns = colWidths.map((width) => ({ width }));
  } else if (source === 'Merchant') {
    const colWidths = [30, 30, 20, 20, 20, 30, 30, 30, 30, ...Object.keys(fields).map((field) => 25)];
    worksheet.columns = colWidths.map((width) => ({ width }));
  } else if (source === 'Meeting') {
    const colWidths = [30, 30, 20, 20, 20, 30, 30, 30, 30, 30, ...Object.keys(fields).map((field) => 25)];
    worksheet.columns = colWidths.map((width) => ({ width }));
  } else if (source === 'Report Logs Pipeline') {
    const colWidths = [20, 20, 20, 20, 20, 20];
    worksheet.columns = colWidths.map((width) => ({ width }));
  } else if (source === 'success-validation-phone') {
    const colWidths = [30, 20, 30, 20, 50];
    worksheet.columns = colWidths.map((width) => ({ width }));
  } else if (source === 'template-validation-phone') {
    const colWidths = [
      { width: 30, style: '@' },
      { width: 30, style: '@' },
    ];
    worksheet.columns = colWidths.map((data) => ({ width: data.width, style: { numFmt: data.style } }));
  } else if (source === 'Attendance') {
    const colWidths = [25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25];
    worksheet.columns = colWidths.map((width) => ({ width }));
  }
};

const addFileInformationDateRange = (worksheet: ExcelJS.Worksheet, dateStart: string, dateEnd: string) => {
  worksheet.getCell('A1').value = `Filter Tanggal dibuat: ${dateStart} - ${dateEnd}`;
  worksheet.mergeCells('A1:Q1'); // Merge cells to make header span across columns

  worksheet.getCell('A1').alignment = {
    vertical: 'middle',
    horizontal: 'left',
    wrapText: true,
  };
  worksheet.getCell('A1').font = {
    name: 'Arial Black',
    size: 12,
  };

  // Set row height
  worksheet.getRow(1).height = 30;
}